"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMinutesToString = exports.formatISODate = exports.getDateModified = exports.getLocaleTime = exports.getYearString = exports.getLocaleDateTimeString = exports.formatSubscriptionDate = exports.getLocaleDateString = void 0;
var moment_1 = __importDefault(require("moment"));
var getLocaleDateString = function (date, locale) {
    return new Date(date).toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' });
};
exports.getLocaleDateString = getLocaleDateString;
var formatSubscriptionDate = function (subscriptionEndDate) {
    if (!subscriptionEndDate || subscriptionEndDate.trim() === '') {
        return 'No date available';
    }
    var endDate = moment_1.default.utc(subscriptionEndDate);
    if (!endDate.isValid()) {
        return 'Invalid Date';
    }
    return endDate.format('MMM D, YYYY');
};
exports.formatSubscriptionDate = formatSubscriptionDate;
var getLocaleDateTimeString = function (date, locale) {
    var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    };
    var formattedDate = new Date(date).toLocaleDateString(locale, options);
    return "".concat(formattedDate);
};
exports.getLocaleDateTimeString = getLocaleDateTimeString;
var getYearString = function (date, locale) {
    var options = {
        year: 'numeric'
    };
    return new Date(date).toLocaleDateString(locale, options);
};
exports.getYearString = getYearString;
var getLocaleTime = function (date, locale) {
    return new Date(date).toLocaleTimeString(locale, {
        hour: '2-digit',
        minute: '2-digit'
    });
};
exports.getLocaleTime = getLocaleTime;
var getDateModified = function (date, locale) {
    var momentDate = (0, moment_1.default)(new Date(date));
    momentDate.locale(locale);
    return momentDate.fromNow();
};
exports.getDateModified = getDateModified;
var formatISODate = function (date) {
    return date.toISOString().split('T')[0];
};
exports.formatISODate = formatISODate;
var parseMinutesToString = function (minutes) {
    if (!minutes)
        return '';
    var hours = Math.floor(minutes / 60);
    var hoursString = hours ? "".concat(hours, "h:") : '';
    return "".concat(hoursString).concat(minutes % 60, "min");
};
exports.parseMinutesToString = parseMinutesToString;
